import React from 'react';

/** Same markdown notes renderer as CustomerDetailsModal call summaries. */
export function renderMarkdownNotes(text) {
  if (!text) return null;
  const lines = text.split('\n');
  const elements = [];
  let bulletItems = [];
  let skipUntilNextHeading = false;

  const flushBullets = () => {
    if (bulletItems.length > 0) {
      elements.push(
        <ul key={`bullets-${elements.length}`} style={{ margin: '4px 0 8px 18px', padding: 0, listStyle: 'disc' }}>
          {bulletItems.map((b, i) => (
            <li key={i} style={{ marginBottom: 3, lineHeight: 1.4 }}>{b}</li>
          ))}
        </ul>,
      );
      bulletItems = [];
    }
  };

  for (const line of lines) {
    const headingMatch = line.match(/^##\s+(.+)/);
    if (headingMatch) {
      const heading = headingMatch[1].trim().toLowerCase();
      if (heading === 'summary' || heading === 'ops') {
        flushBullets();
        skipUntilNextHeading = true;
        continue;
      }
      skipUntilNextHeading = false;
      flushBullets();
      elements.push(
        <div
          key={`h-${elements.length}`}
          style={{
            fontWeight: 700,
            fontSize: '0.8rem',
            color: '#1e40af',
            marginTop: elements.length > 0 ? 10 : 0,
            marginBottom: 2,
            borderBottom: '1px solid #e2e8f0',
            paddingBottom: 2,
          }}
        >
          {headingMatch[1].trim()}
        </div>,
      );
      continue;
    }

    if (skipUntilNextHeading) continue;

    const bulletMatch = line.match(/^\s*[-*]\s+(.+)/);
    if (bulletMatch) {
      bulletItems.push(bulletMatch[1].trim());
      continue;
    }

    const trimmed = line.trim();
    if (trimmed) {
      flushBullets();
      elements.push(
        <div key={`p-${elements.length}`} style={{ marginTop: 2, lineHeight: 1.45 }}>
          {trimmed}
        </div>,
      );
    }
  }
  flushBullets();
  return elements;
}
